// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("background.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-position: center;
	background-attachment: fixed; /* Keeps background static on scroll */
	background-size: cover; /* Covers entire viewport, no white space */
	background-repeat: no-repeat;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
	font-optical-sizing: auto;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	min-height: 100vh; /* Full viewport height */
	overflow-x: hidden; /* No horizontal scrollbars */
  }
  
  code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,yDAAwC;CACxC,2BAA2B;CAC3B,4BAA4B,EAAE,sCAAsC;CACpE,sBAAsB,EAAE,2CAA2C;CACnE,4BAA4B;CAC5B;;cAEa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,mCAAmC;CACnC,kCAAkC;CAClC,iBAAiB,EAAE,yBAAyB;CAC5C,kBAAkB,EAAE,6BAA6B;EAChD;;EAEA;CACD;aACY;EACX","sourcesContent":["body {\n\tmargin: 0;\n\tbackground-image: url(\"background.jpeg\");\n\tbackground-position: center;\n\tbackground-attachment: fixed; /* Keeps background static on scroll */\n\tbackground-size: cover; /* Covers entire viewport, no white space */\n\tbackground-repeat: no-repeat;\n\tfont-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n\tfont-optical-sizing: auto;\n\tfont-style: normal;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tmin-height: 100vh; /* Full viewport height */\n\toverflow-x: hidden; /* No horizontal scrollbars */\n  }\n  \n  code {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
